import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core';
import { DragSource } from 'react-dnd';
import { compose } from '../../../utility';
import LineIcon from '../../../assets/line.svg';
import c from '../../constants';
import styles from './line.styles';
import { linePreview } from './dragPreview';

const lineSource = {
  beginDrag(props) {
    const { id } = props;
    return { id };
  },
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
    connectDragPreview: connect.dragPreview(),
  };
}

type PropType = {
  connectDragPreview: Function,
  connectDragSource: Function,
  handleClick: Function,
  handleKeyDown: Function,
  classes: Object
}

class LineC extends React.PureComponent<PropType, *> {

  componentDidMount() {
    const preview = new Image();
    preview.src = linePreview;
    preview.onload = () => this.props.connectDragPreview && this.props.connectDragPreview(preview, { offsetX: 0, offsetY: 0 });
  }

  render() {
    const {
      connectDragSource, handleClick, classes, handleKeyDown,
    } = this.props;
    return ((
      connectDragSource && connectDragSource((
        <div
          role="button"
          tabIndex="0"
          onKeyDown={ev => handleKeyDown(ev, c.ItemTypes.LINE)}
          onClick={ev => handleClick(ev, c.ItemTypes.LINE)}
          className={classNames(classes.root, 'fieldOutClick')}
          data-testid="lineTool"
        >
          <LineIcon />
          <span className={classes.legend}>Line</span>
        </div>
      ))
    ));
  }

}

export const Line = compose(
  DragSource(c.ItemTypes.LINE, lineSource, collect),
  withStyles(styles, { withTheme: true }),
)(LineC);
